// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1lZH9","title":"Images90_title__3OELs","images":"Images90_images__3pB7n"};